var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('span',{staticClass:"menu-wallet__button",on:{"click":function($event){_vm.showAddress = true}}},[_vm._v(" "+_vm._s(_vm.shortedAddress())+"  "),_c('Jazzicon',{attrs:{"diameter":35,"address":_vm.ethAddress}})],1),_c('MyAccount',{attrs:{"show":_vm.showAddress},on:{"update:show":function($event){_vm.showAddress=$event}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }